import { render, staticRenderFns } from "./Msglist.vue?vue&type=template&id=77013b84&scoped=true&"
import script from "./Msglist.vue?vue&type=script&lang=js&"
export * from "./Msglist.vue?vue&type=script&lang=js&"
import style0 from "./Msglist.vue?vue&type=style&index=0&id=77013b84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77013b84",
  null
  
)

export default component.exports